(() => {
  if (!customElements.get('biri-post-models')) customElements.define('biri-post-models', class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const cards=[...this.querySelectorAll('[data-post-model]')];
      cards.sort((a,b)=>Number(b.dataset.stock==='true')-Number(a.dataset.stock==='true')).forEach(card=>this.querySelector('.biri-post-cards').append(card));
      cards.forEach(card=>card.addEventListener('click',event=>{
        event.preventDefault();
        cards.forEach(c=>c.setAttribute('aria-expanded',String(c===card)));
        this.querySelectorAll('.biri-post-panel').forEach(panel=>{
          panel.hidden=panel.dataset.family!==card.dataset.postModel;
          if(!panel.hidden){panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});panel.querySelector('h2').focus({preventScroll:true});}
        });
      }));
      const openFromHash=()=>{const family=location.hash.replace('#post-','');const card=cards.find(c=>c.dataset.postModel===family);if(card)card.click();};
      openFromHash();window.addEventListener('hashchange',openFromHash);
    }
  });
  if(customElements.get('biri-post-family'))return;
  customElements.define('biri-post-family', class extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.choices=JSON.parse(this.querySelector('[data-post-data]').textContent);
      this.current=this.choices.find(x=>String(x.id)===this.dataset.initial)||this.choices.find(x=>x.available)||this.choices[0];
      if(!this.current)return;
      this.links=this.dataset.mode==='links';
      this.render();
      if(this.links){this.closest('[data-biri-product]')?.setAttribute('data-post-selector-ready','');this.closest('.biri-product-page')?.querySelector('.biri-bulk')?.remove();}
      else this.querySelector('[name=quantity]').addEventListener('input',()=>this.total());
    }
    target(field,value){
      if(this.current[field]===value)return this.current;
      const options=this.choices.filter(x=>x[field]===value);
      const other=field==='colour'?'pack':'colour';
      return options.find(x=>x[other]===this.current[other])||options.find(x=>x.available)||options[0];
    }
    total(){const n=Number(this.querySelector('[name=quantity]').value);this.querySelector('[data-post-total]').textContent=Number.isInteger(n)&&n>0?this.dataset.total+': '+n*this.current.pack:'';}
    render(){
      const selected=this.current;
      this.querySelector('[data-post-colour]').textContent=selected.colour||'';
      ['colour','pack'].forEach(field=>{
        const fieldset=this.querySelector('[data-post-field="'+field+'"]');
        const pool=field==='pack'?this.choices.filter(x=>x.colour===selected.colour):this.choices;
        const values=[...new Set(pool.map(x=>x[field]))];
        if(field==='pack')values.sort((a,b)=>a-b);
        else values.sort((a,b)=>Number(this.choices.some(x=>x.colour===b&&x.available))-Number(this.choices.some(x=>x.colour===a&&x.available)));
        fieldset.hidden=(field==='colour'&&!values.some(Boolean))||(field==='pack'&&values.length===1&&values[0]===1);
        const container=fieldset.querySelector('.biri-post-choices');
        const old=new Map([...container.children].map(x=>[x.dataset.value,x]));
        const nodes=values.map(value=>{
          const target=this.target(field,value),active=selected[field]===value;
          const control=old.get(String(value))||document.createElement(this.links?'a':'button');
          control.dataset.value=String(value);
          control.className='biri-post-choice'+(field==='colour'?' is-swatch':'')+(!target.available?' is-sold-out':'');
          const label=field==='pack'?(value===1?this.dataset.single:this.dataset.set+' '+value):value;
          control.title=label+(!target.available?' — '+this.dataset.sold:'');
          if(this.links){control.href=target.url;if(active)control.setAttribute('aria-current','page');else control.removeAttribute('aria-current');}
          else{control.type='button';control.setAttribute('aria-pressed',String(active));control.onclick=()=>{this.current=target;this.render();};}
          if(field==='colour'){
            control.setAttribute('aria-label',label+(!target.available?' — '+this.dataset.sold:''));
            if(!control.firstChild)control.append(document.createElement('span'));
            const colours={Orange:'#ff761b',Yellow:'#ffd326',Blue:'#1764b0',Green:'#25924c',Black:'#25282c','Red / White':'linear-gradient(135deg,#d9233b 50%,#fff 50%)','Yellow / Black':'linear-gradient(135deg,#ffd326 50%,#25282c 50%)'};
            control.firstChild.style.background=colours[value]||'#eee';
          }else control.textContent=label;
          return control;
        });
        [...container.children].filter(x=>!nodes.includes(x)).forEach(x=>x.remove());
        nodes.forEach((node,i)=>{if(container.children[i]!==node)container.insertBefore(node,container.children[i]||null);});
      });
      const chain=this.querySelector('[data-post-chain]');chain.hidden=!selected.chain;chain.textContent=selected.chain?selected.chain+' '+this.dataset.chainLabel:'';
      if(this.links)return;
      this.querySelector('[data-post-price]').textContent=selected.price;this.querySelector('[data-biri-shipping-badge]').hidden=!selected.shippingIncluded;
      this.querySelector('[data-post-sku]').textContent=selected.sku;
      this.querySelector('[data-post-stock]').textContent=selected.available?this.dataset.available:this.dataset.sold;
      this.querySelector('[data-post-quantity-label]').textContent=selected.pack>1?this.dataset.packs:this.dataset.quantity;
      this.querySelector('[data-post-delivery]').textContent=selected.delivered?this.dataset.delivered:this.dataset.shipping;
      this.querySelector('[data-post-details]').href=selected.url;
      const form=this.querySelector('form');form.querySelector('[name=id]').value=selected.id;
      const pid=form.querySelector('[name="product-id"]');if(pid)pid.value=selected.productId;
      const add=form.querySelector('[type=submit]');add.disabled=!selected.available;add.textContent=selected.available?this.dataset.add:this.dataset.sold;
      this.total();
      if(this.imageId===selected.id)return;this.imageId=selected.id;
      const image=this.querySelector('.biri-post-photo img'),thumbs=this.querySelector('[data-post-thumbnails]');
      const show=i=>{if(image){image.removeAttribute('srcset');image.src=selected.images[i];image.alt=this.dataset.title+(selected.colour?' — '+selected.colour:'');}[...thumbs.children].forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));};
      thumbs.replaceChildren();selected.images.forEach((src,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',this.dataset.title+' — image '+(i+1));const im=document.createElement('img');im.src=src;im.alt='';im.loading='lazy';b.append(im);b.addEventListener('click',()=>show(i));thumbs.append(b);});
      if(selected.images.length)show(0);
    }
  });
})();
